import request from '@/utils/request'

// 查询核心绩效报列表
export function apiGetInvCorePerformanceReportList (query) {
  return request({
    url: `/inv/invCorePerformanceReport/list`,
    method: 'get',
    params: query
  })
}

// 查询核心绩效报列表汇总
export function apiGetInvCorePerformanceReportListSummary (query) {
  return request({
    url: `/inv/invCorePerformanceReport/listSummary`,
    method: 'get',
    params: query
  })
}

// 导出核心绩效报列表
export function apiInvCorePerformanceReportExport (data) {
  return request({
    url: '/inv/invCorePerformanceReport/export',
    method: 'post',
    data: data
  })
}

// 汇总导出
export function apiInvCorePerformanceReportExportSummary (data) {
  return request({
    url: '/inv/invCorePerformanceReport/exportSummary',
    method: 'post',
    data: data
  })
}

// 导出日计划分母明细
export function apiInvCorePerformanceReportExportDailyPlanDenominatorDetail (data) {
  return request({
    url: '/inv/invCorePerformanceReport/exportDailyPlanDenominatorDetail',
    method: 'post',
    data: data
  })
}

// 同步生成核心绩效报列表生成
export function apiInvCorePerformanceReportRefresh (data) {
  return request({
    url: '/inv/invCorePerformanceReport/refresh',
    method: 'post',
    data: data
  })
}
